export interface ModeBarProps {
  /** Rótulo de la vista ("Vista de cuotas"). */
  label: string;
  /** Opción actual ("A la fecha"). */
  value: string;
  /** Si existe, la pastilla es un botón que abre el menú de modos. */
  onClick?(): void;
  /** Estado del menú cuando es botón (`aria-expanded`). */
  expanded?: boolean;
}

const pillClass = "inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full border-[1.5px] border-[var(--ds-ink)] px-4 text-sm font-medium leading-none text-[var(--ds-ink)] md:h-9";

/** ModeBar: rótulo y pastilla con el modo de lectura actual; con `onClick` es un botón de menú. */
export function ModeBar({ label, value, onClick, expanded }: ModeBarProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-base leading-6 text-[var(--ds-ink)]">{label}</span>
      {onClick ? (
        <button
          type="button"
          aria-haspopup="menu"
          aria-expanded={expanded}
          onClick={onClick}
          className={`app-focus-ring cursor-pointer bg-transparent ${pillClass}`}
        >
          {value}
        </button>
      ) : (
        <span className={pillClass}>{value}</span>
      )}
    </div>
  );
}
